module.exports = __webpack_public_path__ + "static/Food-1c9a249f551f57e093bebf38a32e74e2.png";